import { AfterViewInit, Component, EventEmitter, OnChanges, Output, input, model } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog'
import { Router } from '@angular/router';
import { ReportService } from 'src/app/services/report.service';
import { ConfirmationToastComponent } from 'src/app/components/confirmation-toast/confirmation-toast.component';
import Inputmask from "inputmask";

@Component({
  selector: 'app-assessment-cost',
  templateUrl: './assessment-cost.component.html',
  styleUrls: ['./assessment-cost.component.scss'],
  standalone: false
})


export class AssessmentCostComponent implements OnChanges, AfterViewInit {

  report = input.required<any>();
  nav = model.required<string>();
  @Output() loaded = new EventEmitter();

  page = input("5");

  form = this.formBuilder.group({
    assessment_cost: [0],
  });

  constructor(
    public dialog: MatDialog,
    private readonly router: Router,
    private readonly formBuilder: FormBuilder,
    public readonly reportService: ReportService,
    public readonly toast: ConfirmationToastComponent,
  ) {

  }

  async setMask() {
    let assessmentCost = document.getElementById("assessmentCost") ?? '';
    let im = new Inputmask("currency", {
      groupSeparator: ',',
      prefix: '$',
      allowMinus: false
    });
    im.mask(assessmentCost);
    this.form.patchValue({
      assessment_cost: this.report().assessment_cost,
    })
  }

  ngAfterViewInit() {
    this.setMask();
    this.loaded.emit(true);
  }

  ngOnChanges(): void {
    if (this.nav() != '') this.navigate();
  }

  navigate() {
    this.save();
    switch (this.nav()) {
      case 'forward': {
        this.router.navigate(['/2500-8-report'], { queryParams: { report_id: this.report().report_id, report_page_input: 6 } });
        break;
      }
      case 'back': {
        this.router.navigate(['/2500-8-report'], { queryParams: { report_id: this.report().report_id, report_page_input: 4 } });
        break;
      }
      case 'close': {
        this.router.navigate(['fire-overview'], { queryParams: { assessment_id: this.report().assessment_id } });
        break;
      }
      default: {
        if (Number(this.nav()))
          this.router.navigate(['/2500-8-report'], { queryParams: { report_id: this.report().report_id, report_page_input: this.nav() } });
        break;
      }
    }
  }

  save() {
    if (!this.form.dirty) {
      // Don't save if nothing has changed
      return
    }

    // Convert blank number fields to undefined
    let numbers = ["assessment_cost"]
    for (let field of numbers) {
      if (this.form.get(field)?.value === "") {
        this.form.patchValue({ [field]: null })
      } else if (this.form.get(field)?.value != null) {
        if (this.form.get(field)?.value.charAt(0) == "$") {
          this.form.patchValue({ [field]: +this.form.get(field)?.value.substring(1).replaceAll(',', '') })
        } else {
          this.form.patchValue({ [field]: +this.form.get(field)?.value })
        }
      }
    }

    let allFieldsFilled = true

    for (let field in this.form.controls) {
      if (this.form.get(field)?.value === null || this.form.get(field)?.value === "") {
        allFieldsFilled = false
      }
    }

    this.reportService.updateReport({
      report_id: this.report().report_id,

      assessment_cost: this.form.value.assessment_cost as string | undefined,

      [`page_${this.page()}_status_id`]: allFieldsFilled ? 2 : 1,
    }).subscribe({
      next: (response) => {
      },
      error: (response) => {
        this.toast.openErrorSnackBar(`There was an error saving the report`, "Please try again.");
      },
    })
  }

  save_close() {
    this.save();
    this.router.navigate(['fire-overview'], { queryParams: { assessment_id: this.report().assessment_id } });
  }
}
